import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({ }),
  mutations: { },
  actions: {
    async getAddressByCep ({ commit, state }, payload) {
      const cep = await axios.get(`cep/${payload}`)
      return cep
    }
  },
  getters: { }
}
